var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCloseMemberModal(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icCloseMemberModal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M1256.51566,30.5445031 L1265.42908,21.6310738 C1266.24957,20.810582 1266.24957,19.4803052 1265.42908,18.6599307 C1264.60859,17.8394389 1263.27843,17.8394389 1262.45794,18.6599307 L1253.5444,27.5734774 L1244.63086,18.6598133 C1243.81037,17.8393215 1242.48022,17.8393215 1241.65972,18.6598133 C1240.83935,19.4803052 1240.83935,20.810582 1241.65972,21.6309565 L1250.57326,30.5443858 L1241.65972,39.4579324 C1240.83935,40.2784243 1240.83935,41.608701 1241.65972,42.4290755 C1242.48022,43.2495674 1243.81037,43.2495674 1244.63086,42.4290755 L1253.5444,33.5155289 L1262.45794,42.4290755 C1263.27831,43.2495674 1264.60859,43.2495674 1265.42908,42.4290755 C1266.24957,41.6085837 1266.24957,40.2784243 1265.42908,39.4579324 L1256.51566,30.5445031 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Search--Desktop-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "See-picture",
    transform: "translate(-1395.000000, -20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MouseOver-Option",
    transform: "translate(154.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icCloseMemberModal",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseMemberModal);
export default __webpack_public_path__ + "static/media/icCloseMemberModal.f341a15c4b15f9c8d2558c6f9cc7630e.svg";
export { ForwardRef as ReactComponent };